import { Row, Col, Card, Statistic, message, Rate, Pagination } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import './dashboard.css';

const DashBoardPage = () => {
  const [empData, setEmpData] = useState([]);
  const [manData, setManData] = useState([]);
  const [supData, setSupData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const apiUrl = process.env.REACT_APP_API_URL;
  const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
  const navigate = useNavigate();

  const totalRatingEmp = empData
    .filter(employee => employee.reviews && employee.reviews.length > 0)
    .map(employee => {
      const totalRating = employee.reviews.reduce((sum, r) => sum + r.rating, 0);
      return totalRating / employee.reviews.length;
    });

  const generalAverage = totalRatingEmp.length > 0
    ? (totalRatingEmp.reduce((sum, avg) => sum + avg, 0) / totalRatingEmp.length).toFixed(2)
    : 0;

  useEffect(() => {
    const fetchAllModels = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/allModels`);
        if (response.ok) {
          const data = await response.json();
          setEmpData(data.employess || []);
          setManData(data.managers || []);
          setSupData(data.support || []);
        } else {
          message.error("Veriler getirilirken hata oluştu.");
        }
      } catch (error) {
        console.error(error);
        message.error("Sunucu hatası oluştu.");
      }
    };
    fetchAllModels();
  }, [apiUrl]);

  const pendingSup = supData.filter(item => item.status === false);
  const completedSup = supData.filter(item => item.status === true);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentEmpData = empData.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div>
      <Row gutter={16} justify="space-between">
        <Col xs={24} sm={12} md={8}><Card><Statistic title="Toplam Çalışan Sayısı" value={empData.length} /></Card></Col>
        <Col xs={24} sm={12} md={8}><Card><Statistic title="Toplam Yönetici Sayısı" value={manData.length} /></Card></Col>
        <Col xs={24} sm={12} md={8}><Card><Statistic title="Tüm Talepler" value={supData.length} /></Card></Col>
        <Col xs={24} sm={12} md={8}><Card><Statistic title="Bekleyen Talepler" value={pendingSup.length} /></Card></Col>
        <Col xs={24} sm={12} md={8}><Card><Statistic title="Tamamlanan Talepler" value={completedSup.length} /></Card></Col>
        <Col xs={24} sm={12} md={8}><Card><Statistic title="Genel Çalışan Ortalaması" value={generalAverage} suffix=" Puan" /></Card></Col>
      </Row>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          justifyItems: "center",
          marginTop: "50px",
          gap: "20px",
        }}
        className="employess-dashboard-reviews"
      >
        {currentEmpData.map((item) => {
          const totalReviews = item.reviews?.length || 0;
          const averageRating = totalReviews > 0
            ? (item.reviews.reduce((sum, r) => sum + r.rating, 0) / totalReviews).toFixed(1)
            : null;

          const imgSrc = item.img?.startsWith("http")
            ? item.img
            : `${imageBaseUrl}/${item.img}`;

          return (
            <div key={item.id}>
              <Card
                onClick={() => navigate(`employess/${item.id}`)}
                hoverable
                style={{ width: 280 }}
                cover={
                  <img
                    alt={item.name}
                    src={imgSrc}
                    style={{ width: '100%', height: 300, objectFit: 'cover' }}
                  />
                }
              >
                <div className="employess-card-reviews">
                  <p style={{ fontSize: "15px", fontWeight: "bold" }}>{item.name}</p>
                  {averageRating ? (
                    <Rate disabled allowHalf defaultValue={parseFloat(averageRating)} />
                  ) : (
                    <p style={{ color: "gray" }}>Henüz Değerlendirme Yok</p>
                  )}
                  <p style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
                    Yorum Sayısı: {totalReviews}
                  </p>
                </div>
              </Card>
            </div>
          );
        })}
      </div>

      <Pagination
        style={{ textAlign: "center", marginTop: "20px" }}
        current={currentPage}
        pageSize={itemsPerPage}
        total={empData.length}
        onChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
};

export default DashBoardPage;
